import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaDespesasCartaoCorporativo: ['administracao'],
    removeExercicioConsultaDespesasCartaoCorporativo: [],
    removePeriodoUtilizacaoInicialConsultaDespesasCartaoCorporativo: ['periodoUtilizacaoInicial'],
    removePeriodoUtilizacaoFinalConsultaDespesasCartaoCorporativo: ['periodoUtilizacaoFinal'],
    removeNomeConsultaDespesasCartaoCorporativo: ['nome'],
    removeCpfConsultaDespesasCartaoCorporativo: ['cpf'],
    removeCnpjConsultaDespesasCartaoCorporativo: ['cnpj'],
    removeStatusConsultaDespesasCartaoCorporativo: [],
    setMostraAplicarFiltroConsultaDespesasCartaoCorporativo: [],
    limpaFiltroConsultaDespesasCartaoCorporativo: [],
    aplicarFiltroConsultaDespesasCartaoCorporativo: ['filtro'],
})

const INITIAL_STATE = {
    administracao: [],
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    periodoUtilizacaoInicial: '',
    periodoUtilizacaoFinal: '',
    nome: '',
    cpf: '',
    cnpj: '',
    mostraAplicarFiltro: false,
    status: '',
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: '', mostraAplicarFiltro: true }
}

const removePeriodoUtilizacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, periodoUtilizacaoInicial: '', mostraAplicarFiltro: true }
}
const removePeriodoUtilizacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, periodoUtilizacaoFinal: '', mostraAplicarFiltro: true }
}

const removeNome = (state = INITIAL_STATE, action) => {
    return { ...state, nome: '', mostraAplicarFiltro: true }
}

const removeCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: '', mostraAplicarFiltro: true }
}

const removeCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: removeAdministracao,
    [Types.REMOVE_EXERCICIO_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: removeExercicio,
    [Types.REMOVE_PERIODO_UTILIZACAO_INICIAL_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: removePeriodoUtilizacaoInicial,
    [Types.REMOVE_PERIODO_UTILIZACAO_FINAL_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: removePeriodoUtilizacaoFinal,
    [Types.REMOVE_NOME_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: removeNome,
    [Types.REMOVE_CPF_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: removeCpf,
    [Types.REMOVE_CNPJ_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: removeCnpj,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: setMostraAplicarFiltro,
    [Types.REMOVE_STATUS_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: removeStatus,
    [Types.LIMPA_FILTRO_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_DESPESAS_CARTAO_CORPORATIVO]: aplicarFiltro,
})
